<template>
    <el-form :model="form"label-width="150px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="企业类型">
                    {{ entType(form.entType) }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="所属数据服务商" prop="entName">
                    <span>{{ form.platformName }}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="企业名称">
                    {{ form.entName }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="统一社会信用代码" prop="entName">
                    <span>{{ form.creditCode }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="联系人">
                    {{ form.contactName }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系方式" prop="entName">
                    <span>{{ form.contactPhone }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="法人代表">
                    {{ form.legalName }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系方式" prop="entName">
                    <span>{{ form.legalPhone }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-form-item label="注册地址">
                    {{ form.regAddressName+form.regAddressDetail }}
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-form-item label="经营地址">
                    {{ form.workAddressName+form.workAddressDetail }}
                </el-form-item>
            </el-col>

        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="所属街镇">
                    {{ form.addressStreetName+form.addressStreetDetail }}
                </el-form-item>
            </el-col>

        </el-row>
        <el-divider content-position="left">过往开通详情</el-divider>
        <el-row style="border-radius: 2px">
            <el-timeline :reverse="reverse">
                <el-timeline-item
                        v-for="(open, index) in form.opens"
                        :key="index"
                        :timestamp="open.applyTime" placement="top">
                    <span style="margin-left: 0%" v-if="open.chargeType==0"><b>{{status(open.status)}}</b>&nbsp;开通时间：{{open.openTime}} 收费按照：每年{{open.yearFee}}元</span>
                    <span style="margin-left: 0%" v-if="open.chargeType==1"><b>{{status(open.status)}}</b>&nbsp;开通时间：{{open.openTime}} 收费按照：每升{{open.oilLiterPrice}}元,{{open.isCapping==1?'封顶'+open.onlineCost+'元':'不封顶'}}</span>
                </el-timeline-item>
            </el-timeline>
        </el-row>
        <slot name="audit">
            <el-row style="padding-top:20px;">
                <div class="dialog-footer" style="padding-left: 40%">
                    <el-button @click="closeDialog()" size="small">关 闭</el-button>
                </div>
            </el-row>
        </slot>
    </el-form>
</template>

<script>
    import {
        enterpriseDetail
    } from '@/api/admin/sysEnterprise/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'enterpriseDetail',
    props:["entId"],
    data() {
      return {
          form:{

          }
      }
    },
    created() {
      this.init();
    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
        status:function(s){
            if(s==0){
                return "未开通";
            }else if(s==1){
                return "待审核";
            }else if(s==2){
                return "被驳回";
            }else if(s==3){
                return "开通成功";
            }else if(s==-1){
                return "停用";
            }
        },
        init:function(){
            enterpriseDetail({entId: this.entId}).then(response => {
                this.form = response;
            });
        },
        entType:function(type){
            return type==0?"加油企业":"供油企业";
        },
        closeDialog(){
            this.$emit('close')
        }
    }
  }
</script>
